import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export interface GetAccountRestrictedMintAvailableArgs {
  accountAddr: string;
  enabled?: boolean;
}

export function accountRestrictedMintAvailableQueryKey({
  accountAddr,
}: GetAccountRestrictedMintAvailableArgs) {
  return ["accountRestrictedMintAvailable", accountAddr] as const;
}

export function accountRestrictedMintAvailableQuery({
  accountAddr,
}: GetAccountRestrictedMintAvailableArgs) {
  return {
    queryKey: accountRestrictedMintAvailableQueryKey({ accountAddr }),
    queryFn: async () => {
      return await readDexSdk.availableRestrictedMintFor(accountAddr);
    },
  } satisfies FetchQueryOptions;
}

/**
 * Query to check how much USDC an account can still mint (account limit).
 *
 * @remarks This query is temporary and only for use in testnet. The available_restricted_mint_for
 * view function is a testnet-only feature and should be removed before mainnet deployment.
 */
export function useAccountRestrictedMintAvailable(args: GetAccountRestrictedMintAvailableArgs) {
  return useQuery({
    ...accountRestrictedMintAvailableQuery(args),
    enabled: (args.enabled ?? true) && !!args.accountAddr,
  });
}
